/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { CircularProgress } from "@material-ui/core";
import Swal from "sweetalert2";

import NewFeed from "./NewFeed";

import "./style.css";

import { getRequest } from "utils/request";
import { putRequest } from "utils/request";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

import { i18n } from '../../translate/i18n';
import { useNotification } from "hooks/notification";
import { useModal } from "hooks/modal";
import format from "utils/dateFormat";
import exportExcel from "utils/exportExcel";
import { format as formatDateFns} from "date-fns";

export default function SkuteFeed() {
  const [feed, setFeed] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newFeed, setNewFeed] = useState(false);
  const [selectedFeed, setSelectedFeed] = useState({});
  const [update, setUpdate] = useState(0);
  const [globalFilter, setGlobalFilter] = useState('');
  const { toggleHelperId} = useModal();
  const { selectedCompany } = useNotification();

  useEffect(() => {

    setLoading(true);
    getRequest(`/feeds?offset=0&limit=1000&CompanyId=${selectedCompany.id}`)
      .then(function (response) {
          setFeed(response.data);
          setLoading(false);
        }
      )
  }, [update, selectedCompany.id]);


  const handleGoBack = () => {
    setNewFeed(!newFeed);
    setUpdate(update + 1);
  };

  const handleEditFeed = (data) => {
    // 1 - imagem
    // 2 - video
    // 3 - youtube

    let newdata = data;
    newdata.TypeFile = data.FeedFiles[0].typeFile;

    setSelectedFeed(newdata);
    setNewFeed(!newFeed);
  };

  const handleNew = () => {
    setSelectedFeed({});
    setNewFeed(true);
  };

  const handleInativate = (id) => {
    Swal.fire({
      title: i18n.t('attemption'),
      text: i18n.t('deleteFeed'),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: i18n.t('confirmEraseCompany'),
    }).then((result) => {
      if (result.isConfirmed) {
        putRequest(`/feeds/inactivate/${id}`)
        .then(function (response) {
            setUpdate(update + 1);
          }
        )
      }
    });
  };

  const actionButtonsTemplate = (data) => {
    return (
      <div style={{display: "flex", flexDirection: "row"}}>
        <div
          className="action-icon"
          
          style={{ cursor: "pointer", marginRight: 10 }}
          onClick={() => handleEditFeed(data)}
        >
          <i className="mdi mdi-pencil" style={{fontSize: 20}}></i>
        </div>
        <div
          className="action-icon"
          style={{ cursor: "pointer" }}
          onClick={() => handleInativate(data.id)}
        >
          <i className="mdi mdi-delete" style={{fontSize: 20}}></i>
        </div>
      </div>
    )
  }

  const header = (
    <div className="data-table-header"
    >
      <i className="pi pi-search" style={{paddingRight: 10}}></i>
      <input 
        className='input-globalfilter' 
        type="search" 
        onChange={(e) => setGlobalFilter(e.target.value)} 
        placeholder="Buscar" 
        icon="pi pi-search"/>
    </div>
  )
  
  const dateTemplate = (data) => {
    return ( 
      <span>{data.createdAt && format(data.createdAt,"dd/MM/yyyy HH:mm:ss")}</span>
        
    )
  }

  useEffect(() => {
    toggleHelperId(!newFeed ? 17 : 18);
  }, [newFeed]);

  const handleExport = () => {
    let data = [];

    feed.forEach(e => {
      const feedAux = {
        Id: e.id,
        [i18n.t('title')]: e.Title,
        [i18n.t('subtitle')]: e.SubTitle,
        [i18n.t('type')]: e.typeFeedDescrition,
        [i18n.t('description')]: e.Description, 
        [i18n.t('createdAt')]: formatDateFns(new Date(e.createdAt), "dd/MM/yyyy"),
        [i18n.t('likes')]: e.totalLiked,
        [i18n.t('eventsRegistry')]: e.totalRegistered,
        Link: e.Link,
        [i18n.t('linkText')]: e.TextLink,
      }
      data.push(feedAux);
    })

    exportExcel(data, 'Feed Skute')
  }

  return (
    <div style={{overflowY: 'auto', minHeight: 200, minWidth: '100%'}}>
      <div className="col-12">
        <div className="card">
          <div className="card-body">
            <div className="area-header-table-users">
              <h4>Feed SKUTE</h4>
              {!newFeed && (
                <button type="button" onClick={handleExport} className="export-excel" >
                  <i style={{fontSize: 16, marginRight: 5}}className="pi pi-file-excel"/>  
                  <span style={{fontSize: '1vw'}}>{i18n.t('exportAllData')}</span>
                </button>
              )}
            </div>
            {!newFeed ? (
              <>
                <div className="tab-content">
                  <div className="tab-pane show active" id="multi-item-preview">
                    {!loading ? (
                      <DataTable
                      globalFilter={globalFilter}
                      header={header}
                      dataKey="id"
                      rowsPerPageOptions={[25,50,100]} 
                      value={feed}
                      paginator
                      rows={25} 
                      emptyMessage={i18n.t('noFeedFinded')}
                    >
                       <Column  field="Title" header={i18n.t('title')} sortable></Column>
                       <Column field="typeFeedDescrition" header={i18n.t('type')} sortable></Column>
                       <Column body={dateTemplate} filterField='createdAt' header={i18n.t('createdAt')}></Column>
                       <Column field="totalLiked" header={i18n.t('likes')} sortable></Column>
                       <Column field="totalRegistered" header={i18n.t('eventsRegistry')} sortable></Column>
                       <Column body={actionButtonsTemplate} field="action" header={i18n.t('action')}></Column>
                    </DataTable>
                    ) : (
                      <div className="area-loading">
                        <CircularProgress />
                      </div>
                    )}
                  </div>
                </div>
                <div
                  className="button-add-relative"
                  onClick={() => handleNew()}
                >
                  <i className="mdi mdi-plus"></i>
                </div>
              </>
            ) : (
              <NewFeed
                companyId={selectedCompany.id}
                selectedFeed={selectedFeed}
                handleGoBack={handleGoBack}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
